import { observer, inject } from 'mobx-react';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import { Card, Tab, Tabs } from '@blueprintjs/core';
import { Instance } from 'mobx-state-tree';

import { AuthenticationStore, LocaleStore } from '../../store';
import MunicipalityUpload from './Municipalities/MunicipalityUpload';
import MunicipalityList from './Municipalities/MunicipalityList';
import { css } from 'emotion';
import MunicipalityCreation from './Municipalities/MunicipalityCreation';

interface RefDataTabProps extends WithTranslateProps {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  LocaleStore?: Instance<typeof LocaleStore>;
}

interface RefDataTabState {}

@inject('AuthenticationStore', 'LocaleStore')
@observer
class RefDataTab extends React.Component<RefDataTabProps, RefDataTabState> {
  render() {
    const { translate } = this.props;
    return (
      <Container>
        <Card className={CardStyle.toString()}>
          <Tabs>
            <Tab
              id="uploadMunicipalities"
              title={translate(TLCode.TRANSFER_MunicipalityUpload)}
              panel={<MunicipalityUpload />}
            />
            <Tab
              id="editMunicipalities"
              title={translate(TLCode.TRANSFER_MunicipalityEdition)}
              panel={<MunicipalityList />}
            />
            <Tab
              id="addMunicipality"
              title={translate(TLCode.TRANSFER_MunicipalityCreation)}
              panel={<MunicipalityCreation />}
            />
          </Tabs>
        </Card>
      </Container>
    );
  }
}

export default withTranslate(RefDataTab);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});
